import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const DOCENTES_CONST = 'docentes';
export const docentesApi = `${baseUrl}/${DOCENTES_CONST}`;
export const docenteSeccionesApi = `${baseUrl}/docente-secciones`;
export const docenteMateriassApi = `${baseUrl}/docente-materias`;
export const docenteDiasClasesApi = `${baseUrl}/docente-dias-clases`;
export const docenteBloquesHorasApi = `${baseUrl}/docente-bloques-horas`;

export const allDocentesService = async (params) => {
  const res = await axios.get(docentesApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const oneDocentesService = async (id) => {
  const res = await axios.get(`${docentesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const asignarMateriasDocentesService = async (data) => {
  const res = await axios.post(docenteMateriassApi, data, {
    headers: token({}),
  });
  return res;
};

export const deleteMateriasDocentesService = async (id) => {
  const res = await axios.delete(`${docenteMateriassApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const asignarSeccionesDocentesService = async (data) => {
  const res = await axios.post(docenteSeccionesApi, data, {
    headers: token({}),
  });
  return res;
};

export const deleteSeccionesDocentesService = async (id) => {
  const res = await axios.delete(`${docenteSeccionesApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const asignarDiasClasesDocentesService = async (data) => {
  const res = await axios.post(docenteDiasClasesApi, data, {
    headers: token({}),
  });
  return res;
};

export const allBloquesDocentesService = async (params) => {
  const res = await axios.get(`${docenteBloquesHorasApi}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const asignarBloquesDocentesService = async (data) => {
  const res = await axios.post(`${docenteBloquesHorasApi}`, data, {
    headers: token({}),
  });
  return res;
};

export const deleteBloquesDocentesService = async (id) => {
  const res = await axios.delete(`${docenteBloquesHorasApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
